import { Injectable } from '@angular/core';

import { Feature } from '../core';
import { EnvironmentConfigurationService } from './env.config.service';
import { PropertiesControllerService, SupplierReferencingPropertiesDto } from '@scip/api';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  private displaySupplierScipData = true;
  private editSupplierScipData = true;
  private useSupplierScipDataGlobal = true;
  constructor(private env: EnvironmentConfigurationService, private propertiesControllerService: PropertiesControllerService) {}

  /**
   * Checks if a given or multiple features are active. If multiple features are given, all of them must be active.
   * @param {Feature | Feature[]} features the features to check
   * @returns {boolean} if the features are active or not
   */
  isActive(features: Feature | Feature[]): boolean {
    const featureNames: Feature[] = this.toArray(features);
    return featureNames.reduce((active: boolean, featureName: Feature) => active && this.checkIfFeatureActive(featureName), true);
  }
  initializeFeatureConfig() {
    this.propertiesControllerService.getSupplierReferencingProperties().subscribe((properties: SupplierReferencingPropertiesDto) => {
      this.displaySupplierScipData = properties.displaySupplierScipData;
      this.editSupplierScipData = properties.editSupplierScipData;
      this.useSupplierScipDataGlobal = properties.useSupplierScipDataGlobal;
    });
  }

  private toArray(features: Feature | Feature[]): Feature[] {
    return features instanceof Array ? features : [features];
  }

  private checkIfFeatureActive(featureName: Feature): boolean {
    switch (featureName) {
      case Feature.LE_GROUPING: {
        return this.env.environment.feature.leGrouping;
        break;
      }
      case Feature.SHOW_SUPPLIERREFERENCE: {
        return this.displaySupplierScipData && this.useSupplierScipDataGlobal;
        break;
      }
      case Feature.EDIT_SUPPLIERREFERENCE: {
        return this.editSupplierScipData && this.useSupplierScipDataGlobal;
        break;
      }
      default:
        return false;
    }
  }
}
